/**
 * @author yueheqin
 * @date 2018/12/13
 * @project kaoshizhongxin-pc
 * @description 登录相关页面
 */
export const auth = [
  // { // qq 第三方登录回调地址,改版遗留地址 /User/Index/QQCallBack
  //   path: '/User/Index/QQCallBack',
  //   name: 'QQCallBack',
  //   component: () => import('../views/qq-callback'),
  //   meta: { title: '登录', auth: false }
  // },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: () => import('../views/login'),
  //   meta: { title: '登录', auth: false }
  // },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import('../views/register'),
  //   meta: { title: '注册', auth: false }
  // },
  // {
  //   path: '/find-pwd',
  //   name: 'FindPassword',
  //   component: () => import('../views/find-password'),
  //   meta: { title: '找回密码' }
  // },
  // {
  //   path: '/oauth/bind-account',
  //   name: 'OauthBindAccount',
  //   component: () => import('../views/oauth-bind-account'),
  //   meta: { title: '绑定手机号' }
  // }
]
